import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import Logo from "./Logo";

const Footer = () => (
  <footer className="grain bg-[#1A2621] text-[#F3EFE5]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 relative z-[2]">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo dark />
          <p className="mt-5 font-head font-bold uppercase text-2xl sm:text-3xl leading-tight text-[#F3EFE5]">
            Good websites for people<br />doing good work.
          </p>
        </div>
        <div className="md:col-span-3">
          <h2 className="font-head font-bold uppercase tracking-[0.2em] text-sm text-[#C58A47]">Pages</h2>
          <ul className="mt-4 space-y-2 text-sm text-[#F3EFE5]/70">
            <li><Link className="hover:text-[#F3EFE5] transition-colors" to="/" data-testid="footer-home">Home</Link></li>
            <li><Link className="hover:text-[#F3EFE5] transition-colors" to="/services" data-testid="footer-services">Services & Pricing</Link></li>
            <li><Link className="hover:text-[#F3EFE5] transition-colors" to="/work" data-testid="footer-work">Our Work</Link></li>
            <li><Link className="hover:text-[#F3EFE5] transition-colors" to="/about" data-testid="footer-about">About</Link></li>
            <li><Link className="hover:text-[#F3EFE5] transition-colors" to="/contact" data-testid="footer-contact">Contact</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <h2 className="font-head font-bold uppercase tracking-[0.2em] text-sm text-[#C58A47]">Get in touch</h2>
          <ul className="mt-4 space-y-3 text-sm text-[#F3EFE5]/70">
            <li className="flex items-center gap-2">
              <Mail size={15} className="text-[#C58A47] shrink-0" />
              <a href="mailto:goodworkweb1@gmail.com" className="hover:text-[#F3EFE5] transition-colors" data-testid="footer-email">goodworkweb1@gmail.com</a>
            </li>
            <li className="flex items-center gap-2">
              <MapPin size={15} className="text-[#C58A47] shrink-0" />
              <span data-testid="footer-location">Almaguin Highlands, Northern Ontario</span>
            </li>
          </ul>
          <p className="mt-6 text-xs text-[#F3EFE5]/40 leading-relaxed">
            Proudly serving Bear Lake, Burk's Falls, Callander, Dunchurch, Emsdale, Katrine, Kearney, Port Loring, Magnetawan, Novar, Powassan, Restoule, South River, Sprucedale, and Sundridge.
          </p>
        </div>
      </div>
      <div className="mt-14 pt-6 border-t border-[#F3EFE5]/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#F3EFE5]/40">
        <span>© {new Date().getFullYear()} Good Work Web Co. All rights reserved.</span>
        <span className="flex items-center gap-4">
          <span>Built right here in the Almaguin Highlands.</span>
          <Link to="/admin" data-testid="footer-owner-login" className="hover:text-[#C58A47] transition-colors">
            Owner Login
          </Link>
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
